const INSTRUMENT_TABLE_ITEMS = {
  lastPrice: 'lastPrice',
  dailyPercentageChange: 'dailyPercentageChange',
  bid: 'bid',
  ask: 'ask',
  dailyVolume: 'dailyVolume',
  dailyMin: 'dailyMin',
  dailyMax: 'dailyMax'
};

export default INSTRUMENT_TABLE_ITEMS;
